import { cva } from "class-variance-authority";
// -----------------------------------------------------------------------------

export default {
  currencySwitcher: {},

  product: {
    root: cva(),

    card: {
      root: cva(
        "bg-surface relative flex w-full flex-wrap items-stretch gap-6 rounded-lg border p-6 text-base",
        {
          variants: {
            isProcessing: {
              true: "",
              false: ""
            },
            isDisabled: {
              true: "",
              false: ""
            },
            isInvalid: {
              true: "",
              false: ""
            }
          },

          defaultVariants: {
            isDisabled: false,
            isInvalid: true
          }
        }
      ),
      wrapper: cva("flex w-full flex-1 flex-wrap items-stretch gap-6"),
      media: cva("m-0 size-20 flex-none overflow-hidden rounded-lg p-0", {
        variants: {
          filled: {
            true: "bg-base-muted text-base-muted-foreground border"
          }
        }
      }),
      header: cva(
        "flex flex-1 flex-col items-start justify-center gap-2 text-left"
      ),
      content: cva(
        "order-last flex w-full flex-none flex-wrap gap-6 border-t pt-4 empty:hidden"
      ),
      collapsible: cva(
        "max-h-0 overflow-hidden opacity-0 transition aria-expanded:max-h-fit aria-expanded:opacity-100 aria-hidden:hidden"
      ),
      footer: cva(
        "flex max-w-xs flex-1 items-center justify-start gap-6 text-right"
      ),
      // ---
      loading: cva("size-7"),
      title: cva(
        "m-0 inline-flex w-full items-center gap-2 text-2xl leading-none font-normal tracking-wide"
      ),
      meta: cva(
        "text-muted m-0 flex w-full items-center gap-4 text-left text-sm leading-snug lowercase"
      ),

      text: cva("m-0 w-full text-left text-sm leading-normal"),
      bold: cva("font-medium", {
        variants: {
          isCalculating: {
            true: "opacity-50"
          }
        }
      }),
      total: cva("text-2xl leading-snug font-medium tracking-wide"),
      discount: cva(
        "text-md text-muted leading-snug font-normal tracking-wide line-through"
      ),
      pricing: cva("flex flex-row gap-2 text-right font-medium"),
      // ---
      toggle: cva("size-3 transition-all aria-checked:rotate-180"),
      image: cva("h-full w-full object-cover"),
      actions: cva("flex items-center gap-2"),
      actionConfigure: cva("relative", {
        variants: {
          // hasErrors: {
          //   true: "motion-safe:animate-pulse",
          // },
          // isNew: {
          //   true: "motion-safe:animate-pulse",
          // },
        }
      }),
      summary: cva("inline-flex flex-col"),
      // ---
      details: {
        root: cva("m-0 grid w-full list-none grid-cols-4 gap-6 px-0 py-4"),
        item: cva("m-0 flex flex-wrap gap-0 p-0"),
        title: cva(
          "text-muted m-0 w-full p-0 text-sm font-normal tracking-wide"
        ),
        text: cva("m-0 p-0 text-sm tracking-wide"),
        invalid: cva("text-danger-default")
      }
    },

    config: {
      root: cva("w-full text-base", {
        variants: {
          isDisabled: {
            true: "pointer-events-none"
          }
          // hasErrors: {
          //   true: "ring-invalid ring-2 ring-offset-2",
          // },
          // isNew: {
          //   true: "ring-ring ring-2 ring-offset-2",
          // },
        }
      }),

      header: cva(
        "flex items-center justify-center gap-2 px-6 py-1 text-center text-sm",
        {
          variants: {
            // hasErrors: {
            //   true: "bg-error text-error-foreground",
            // },
            // isNew: {
            //   true: "bg-accent text-accent-foreground",
            // },
          }
        }
      ),

      content: cva("flex flex-wrap items-start"),

      media: cva("m-0 size-24 flex-none overflow-hidden rounded-lg p-0", {
        variants: {
          filled: {
            true: "bg-base-muted text-base-muted-foreground border"
          }
        }
      }),

      wrapper: cva(
        "flex w-full flex-1 flex-wrap items-stretch gap-x-6 gap-y-16"
      ),

      heading: cva("flex w-full flex-wrap items-end gap-x-10 gap-y-2"),

      headingContent: cva("flex w-full flex-1 flex-wrap items-center gap-4"),

      summary: cva("inline-flex items-end gap-x-6 gap-y-6", {
        variants: {
          isCalculating: {
            true: "text-opacity-50"
          }
        }
      }),

      fields: cva("flex w-full flex-none flex-wrap items-start empty:hidden", {
        variants: {
          divide: {
            hidden: "",
            solid:
              "divide-y divide-solid [&>*:first-child]:pt-0 [&>*:last-child]:pb-0",
            dashed:
              "divide-y divide-dashed [&>*:first-child]:pt-0 [&>*:last-child]:pb-0",
            dotted:
              "divide-y divide-dotted [&>*:first-child]:pt-0 [&>*:last-child]:pb-0"
          },
          spacing: {
            "2": "",
            "4": "",
            "6": "",
            "8": "",
            "10": ""
          }
        },
        compoundVariants: [
          { divide: "hidden", spacing: "2", class: "gap-2" },
          { divide: "hidden", spacing: "4", class: "gap-4" },
          { divide: "hidden", spacing: "6", class: "gap-6" },
          { divide: "hidden", spacing: "8", class: "gap-8" },
          { divide: "hidden", spacing: "10", class: "gap-10" }
        ]
      }),

      field: cva("", {
        variants: {
          divide: {
            hidden: "",
            solid: "",
            dashed: "",
            dotted: ""
          },
          spacing: {
            "2": "",
            "4": "",
            "6": "",
            "8": "",
            "10": ""
          }
        },
        compoundVariants: [
          {
            divide: ["solid", "dashed", "dotted"],
            spacing: "2",
            class: "py-2"
          },
          {
            divide: ["solid", "dashed", "dotted"],
            spacing: "4",
            class: "py-4"
          },
          {
            divide: ["solid", "dashed", "dotted"],
            spacing: "6",
            class: "py-6"
          },
          {
            divide: ["solid", "dashed", "dotted"],
            spacing: "8",
            class: "py-8"
          },
          {
            divide: ["solid", "dashed", "dotted"],
            spacing: "10",
            class: "py-10"
          }
        ]
      }),

      footer: cva(
        "mt-6 flex w-full items-center justify-between gap-x-10 border-t px-6 py-4"
      ),
      // ---
      loading: cva("size-7"),
      title: cva("m-0 text-2xl leading-none tracking-wide"),
      meta: cva(
        "text-muted m-0 flex w-full items-center gap-4 text-left text-sm leading-snug lowercase"
      ),
      text: cva("text-muted m-0 w-full text-left leading-normal"),
      bold: cva("font-medium", {
        variants: {
          isCalculating: {
            true: "text-opacity-50"
          }
        }
      }),
      // ---
      total: cva(
        "block text-right text-2xl leading-snug font-medium tracking-wide",
        {
          variants: {
            isCalculating: {
              true: "text-opacity-50"
            }
          }
        }
      ),
      itemtotal: cva(
        "text-muted m-0 flex w-full items-end justify-end gap-2 leading-normal",
        {
          variants: {
            isCalculating: {
              true: "text-opacity-50"
            }
          }
        }
      ),
      discount: cva(
        "text-md text-muted block w-full text-right leading-snug font-normal tracking-wide line-through",
        {
          variants: {
            isCalculating: {
              true: "text-opacity-50"
            }
          }
        }
      ),
      price: cva(""),
      // ---
      image: cva("h-full w-full object-cover"),
      actions: cva("flex items-center gap-2"),

      // ---
      list: {
        root: cva("w-full p-0"),
        item: {
          header: cva(
            "flex flex-1 flex-wrap items-center justify-between gap-x-2 gap-y-0"
          ),
          footer: cva("flex flex-shrink-1 items-center justify-end gap-4"),
          title: cva("text-md m-0 font-normal"),
          badges: cva("flex items-center justify-end gap-4 px-4"),
          price: cva("min-w-20 text-right"),
          total: cva(
            "text-md block text-right leading-snug font-medium tracking-wide"
          ),
          discount: cva(
            "text-muted block text-right text-sm leading-snug font-normal tracking-wide line-through"
          )
        }
      },
      // ---
      form: {
        root: cva("w-full p-0", {
          variants: {
            disabled: {
              // true: "pointer-events-none",
            }
          }
        }),
        form: cva("")
      }
    },

    notFound: {
      root: cva(
        "relative flex w-full flex-col flex-wrap items-center justify-center gap-1 px-4 py-16 md:px-8"
      ),
      title: cva("m-0 mt-3 text-center text-3xl text-inherit"),
      text: cva(
        "m-0 mb-8 max-w-md text-center text-lg leading-normal opacity-50"
      ),
      avatar: cva("bg-primary size-20 p-2 text-base"),
      actions: cva("flex w-full justify-center")
    },

    pricing: {
      exPrice: cva("text-muted text-xs leading-none"),
      currentPrice: cva("leading-none")
    },

    summary: cva(""),

    actions: cva("flex w-full flex-col gap-6 font-medium lg:flex-row")
  }
};
